import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  Flex,
  Switch,
  Text,
  useColorMode,
  useColorModeValue,
  Image
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import ProfileBgImage from "assets/img/backarrowlong.jpg";
import { Separator } from "components/Separator/Separator";
import logoSmartBots from "assets/img/logo.png";
import { LogOut } from "lucide-react";
import { LOGOUT } from "state/actions/types";
import Header from "views/Dashboard/Profile/components/Header";
import { getUserProfile } from "state/actions/userActions";

export default function Configurator(props) {
  const { secondary, isOpen, onClose, fixed, ...rest } = props;
  const [switched, setSwitched] = useState(props.isChecked);
  const { colorMode, toggleColorMode } = useColorMode();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { userProfile } = useSelector((state) => state.users);

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'en' ? 'tn' : 'en');
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");

    dispatch({ type: LOGOUT });

    history.push("/auth/signin");
  };


    useEffect(() => {
      dispatch(getUserProfile());
    }, []);

  let fixedDisplay = "flex";
  if (props.secondary) {
    fixedDisplay = "none";
  }

  let bgButton = useColorModeValue(
    "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
    "white"
  );
  let colorButton = useColorModeValue("white", "gray.700");
  const secondaryButtonBg = useColorModeValue("white", "transparent");
  const secondaryButtonBorder = useColorModeValue("gray.700", "white");
  const secondaryButtonColor = useColorModeValue("gray.700", "white");
  const settingsRef = React.useRef();
    const bgProfile = useColorModeValue(
      "hsla(0,0%,100%,.8)",
      "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
    );


  return (
    <>
      <Drawer
        isOpen={props.isOpen}
        onClose={props.onClose}
        placement={document.documentElement.dir === "rtl" ? "left" : "right"}
        finalFocusRef={settingsRef}
        blockScrollOnMount={false}
      >
        <DrawerContent>
          <DrawerHeader pt="24px" px="24px">
            <DrawerCloseButton />
            <Text fontSize="xl" fontWeight="bold" mt="16px">
              {t('Mogoma')}
            </Text>
            <Text fontSize="md" mb="16px">
              {t('see_dashboard_options')}
            </Text>
            <Separator />
          </DrawerHeader>
          <DrawerBody w="340px" ps="24px" pe="40px">
            <Flex flexDirection="column">
              <Box>
                <Text fontSize="md" fontWeight="600">
                  {t('sidenav_type')}
                </Text>
                <Text fontSize="sm" mb="16px">
                  {t('choose_sidenav')}
                </Text>
                <Flex>
                  <Button
                    w="50%"
                    p="8px 32px"
                    me="8px"
                    colorScheme="blue"
                    borderColor="#1E3A8A" // Use the darker gradient color for border
                    color="#1E3A8A" // Match the text color to the gradient
                    variant="outline"
                    fontSize="xs"
                    onClick={props.onTransparent}
                  >
                    {t('transparent')}
                  </Button>
                  <Button
                    type="submit"
                    bg="#071D54" // Using a linear gradient for the background
                    w="50%"
                    p="8px 32px"
                    mb={5}
                    _hover={{ bg: "#1E3A8A" }} // Change background to the darker gradient color on hover
                    color="white"
                    fontSize="xs"
                    onClick={props.onOpaque}
                  >
                    {t('opaque')}
                  </Button>
                </Flex>

              </Box>
              <Box
                display={fixedDisplay}
                justifyContent="space-between"
                mb="16px"
              >
                {/* <Text fontSize="md" fontWeight="600" mb="4px">
                  {t('navbar_fixed')}
                </Text>
                <Switch
                  colorScheme="teal"
                  isChecked={switched}
                  onChange={(event) => {
                    if (switched === true) {
                      props.onSwitch(false);
                      setSwitched(false);
                    } else {
                      props.onSwitch(true);
                      setSwitched(true);
                    }
                  }}
                /> */}
              </Box>
              <Flex
                justifyContent="space-between"
                alignItems="center"
                mb="24px"
              >
                <Text fontSize="md" fontWeight="600" mb="4px">
                  {t('dark_light')}
                </Text>
                <Button onClick={toggleColorMode}>
                  {t('toggle_dark_light')}
                </Button>
              </Flex>
              <Flex
                justifyContent="space-between"
                alignItems="center"
                mb="24px"
              >

              </Flex>
              <Separator />
              <Header
                backgroundHeader={false}
                backgroundProfile={bgProfile}
                name={`${userProfile?.first_name} ${userProfile?.last_name}` || userProfile?.username || "Unknown User"}
                email={userProfile?.email || ""}
                tabs={[]}
                
              />
              <Flex justifyContent="center" alignItems="center" mt="60px" cursor="pointer" onClick={handleLogout}>
                <Box as={LogOut} color="red.500" boxSize={6} mr={2} />
                <Text color="red.500" fontWeight="bold">
                  {"Logout"}
                </Text>
              </Flex>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}

Configurator.propTypes = {
  secondary: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  fixed: PropTypes.bool,
};
